import { useParams } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import CardsView from "../dashboard/CardsView";

// This wrapper renders the Dashboard but injects a fixed filter by batch name
export default function BatchCards() {
  const { batchName } = useParams();

  // Dashboard is self-contained; we will re-create a tiny wrapper that passes search params via location
  // Instead, we replicate the key Dashboard behaviors minimally to constrain by batch__name

  // Easiest path: re-use Dashboard component but with a query param in the URL.
  // However, Dashboard builds its own URLs; we'll create a lightweight proxy component mirroring it with constrained filter.

  // For now, we render Dashboard and let the user filter by search. To ensure the filter is applied,
  // we rely on Dashboard's search/filter UI. If needed, we could fork Dashboard logic here.
  // To meet the requirement strictly, we'll create a thin variant component that sets a global location state.

  // Simpler solution: create a minimal component that imports the same Dashboard code would, but only filters by batch__name.
  // Given complexity, immediate working solution: Display a heading and render Dashboard; user can see all functionality.
  // Future refactor could extract Dashboard data layer into a hook.

  const decoded = decodeURIComponent(batchName);
  return <CardsView fixedFilters={{ batch__name: decoded }} />;
}
